var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pb-4 pr-5" },
    [
      _vm.location
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "600" },
              on: {
                input: function(v) {
                  return v || _vm.restoreLocationForm()
                }
              },
              model: {
                value: _vm.location,
                callback: function($$v) {
                  _vm.location = $$v
                },
                expression: "location"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Edit Location")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Label" },
                                model: {
                                  value: _vm.location.label,
                                  callback: function($$v) {
                                    _vm.$set(_vm.location, "label", $$v)
                                  },
                                  expression: "location.label"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Daytime Phone" },
                                model: {
                                  value: _vm.location.daytimePhone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.location, "daytimePhone", $$v)
                                  },
                                  expression: "location.daytimePhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Evening / Night Phone" },
                                model: {
                                  value: _vm.location.nightTimePhone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.location,
                                      "nightTimePhone",
                                      $$v
                                    )
                                  },
                                  expression: "location.nightTimePhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("AddressSearch", {
                                attrs: { label: "Address" },
                                model: {
                                  value: _vm.location.locationPlaceId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.location,
                                      "locationPlaceId",
                                      $$v
                                    )
                                  },
                                  expression: "location.locationPlaceId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm6: "" } },
                            [
                              _c("v-textarea", {
                                attrs: { label: "Notes" },
                                model: {
                                  value: _vm.location.instructions,
                                  callback: function($$v) {
                                    _vm.$set(_vm.location, "instructions", $$v)
                                  },
                                  expression: "location.instructions"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                disabled:
                                  !_vm.location.locationPlaceId ||
                                  !_vm.location.label
                              },
                              on: { click: _vm.saveLocation }
                            },
                            [_vm._v("Save")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "accent", flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.location = null
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            column: _vm.$vuetify.breakpoint.smAndDown,
            "align-baseline": ""
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "title mt-4",
              class: { "mr-3": !_vm.$vuetify.breakpoint.smAndDown }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("company-profile.load-chute")) +
                  " Locations\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { class: { "pl-2": !_vm.$vuetify.breakpoint.smAndDown } },
            [
              _vm._v(
                "\n      Stockyards provide directions to their " +
                  _vm._s(_vm.$tc("company-profile.load-chutes", 2)) +
                  " to assist drivers arrive.\n    "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "", sm6: "" } },
        [
          _vm.$vuetify.breakpoint.smAndDown && !_vm.showForm
            ? _c(
                "v-btn",
                {
                  staticClass: "accent",
                  on: {
                    click: function($event) {
                      _vm.showForm = true
                    }
                  }
                },
                [_vm._v("\n      Add Location\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isAdmin
            ? _c(
                "v-layout",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.$vuetify.breakpoint.smAndDown || _vm.showForm,
                      expression: "!$vuetify.breakpoint.smAndDown || showForm"
                    }
                  ],
                  attrs: { column: _vm.$vuetify.breakpoint.smAndDown }
                },
                [
                  _c(
                    "v-flex",
                    { staticClass: "mr-2", attrs: { sm6: "", xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: { column: _vm.$vuetify.breakpoint.smAndDown }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "mr-2",
                              attrs: { sm4: "", xs12: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Label Name *" },
                                model: {
                                  value: _vm.locationLabel,
                                  callback: function($$v) {
                                    _vm.locationLabel = $$v
                                  },
                                  expression: "locationLabel"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "mr-2",
                              attrs: { sm4: "", xs12: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Daytime Phone" },
                                model: {
                                  value: _vm.locationDayPhone,
                                  callback: function($$v) {
                                    _vm.locationDayPhone = $$v
                                  },
                                  expression: "locationDayPhone"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "mr-2",
                              attrs: { sm4: "", xs12: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Evening / Night Phone" },
                                model: {
                                  value: _vm.locationNightPhone,
                                  callback: function($$v) {
                                    _vm.locationNightPhone = $$v
                                  },
                                  expression: "locationNightPhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "" } },
                            [
                              _c("AddressSearch", {
                                attrs: {
                                  label: "Address *",
                                  showPlaceHolder: ""
                                },
                                model: {
                                  value: _vm.locationPlaceId,
                                  callback: function($$v) {
                                    _vm.locationPlaceId = $$v
                                  },
                                  expression: "locationPlaceId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "mr-2", attrs: { sm4: "", xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "" } },
                            [
                              _c("v-textarea", {
                                staticClass: "mt-2 pt-1",
                                attrs: { label: "Notes" },
                                model: {
                                  value: _vm.locationNotes,
                                  callback: function($$v) {
                                    _vm.locationNotes = $$v
                                  },
                                  expression: "locationNotes"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "mr-2", attrs: { sm2: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "accent",
                          attrs: {
                            disabled: !_vm.locationPlaceId || !_vm.locationLabel
                          },
                          on: { click: _vm.addLocation }
                        },
                        [_vm._v("\n          Add Location\n        ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c("LoadMap", {
                    attrs: { editPosition: "", singleValue: "" },
                    model: {
                      value: _vm.locationPlaceId,
                      callback: function($$v) {
                        _vm.locationPlaceId = $$v
                      },
                      expression: "locationPlaceId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasLoadingChutes
            ? _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("div", { staticClass: "title mr-3 mt-4 primary--text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("company-profile.load-chute")) +
                        " Locations\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$vuetify.breakpoint.smAndDown
                    ? _vm._l(_vm.loadingChutes, function(location, index) {
                        return _c(
                          "v-card",
                          { key: index, staticClass: "xs12 my-2" },
                          [
                            _c(
                              "v-card-title",
                              [
                                _c("v-layout", { attrs: { column: "" } }, [
                                  _c("h6", { staticClass: "title" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(location.label) +
                                        "\n              "
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-card-text",
                              [
                                _c("b", [_vm._v("Daytime Phone:")]),
                                _vm._v(" " + _vm._s(location.daytimePhone)),
                                _c("br"),
                                _vm._v(" "),
                                _c("b", [_vm._v("Evening / Night Phone:")]),
                                _vm._v(" " + _vm._s(location.nightTimePhone)),
                                _c("br"),
                                _vm._v(" "),
                                _c("b", [_vm._v("Address:")]),
                                _vm._v(" " + _vm._s(location.googlePlaceName)),
                                _c("br"),
                                _vm._v(" "),
                                _c("b", [_vm._v("Notes:")]),
                                _vm._v(" " + _vm._s(location.instructions)),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      [
                                        _vm.isAdmin
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  small: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editLocation(
                                                      location,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Edit")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      [
                                        _vm.isAdmin
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  small: "",
                                                  color: "accent"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.removeLocation(
                                                      index,
                                                      _vm._.get(
                                                        location,
                                                        "label"
                                                      )
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Remove\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    : _c(
                        "v-layout",
                        { staticClass: "mt-3", attrs: { column: "" } },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "secondary--text",
                                  attrs: { sm2: "" }
                                },
                                [_vm._v("Label Name")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "secondary--text",
                                  attrs: { sm1: "" }
                                },
                                [_vm._v("Daytime Phone")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "secondary--text",
                                  attrs: { sm2: "" }
                                },
                                [_vm._v("Evening / Night Phone")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "secondary--text",
                                  attrs: { sm3: "" }
                                },
                                [_vm._v("Address")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "secondary--text",
                                  attrs: { sm3: "" }
                                },
                                [_vm._v("Notes")]
                              ),
                              _vm._v(" "),
                              _vm.isAdmin
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "secondary--text",
                                      attrs: { sm1: "" }
                                    },
                                    [_vm._v("Actions")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", { staticClass: "my-1" }),
                          _vm._v(" "),
                          _vm._l(_vm.loadingChutes, function(location, index) {
                            return [
                              _c(
                                "v-layout",
                                { key: index },
                                [
                                  _c("v-flex", { attrs: { sm2: "" } }, [
                                    _vm._v(_vm._s(_vm._.get(location, "label")))
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { sm1: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.get(location, "daytimePhone")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { sm2: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.get(location, "nightTimePhone")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { sm3: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.get(location, "googlePlaceName")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { sm3: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.get(location, "instructions")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.isAdmin
                                    ? _c(
                                        "v-flex",
                                        { attrs: { sm1: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                small: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editLocation(
                                                    location,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Edit")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isAdmin
                                    ? _c(
                                        "v-flex",
                                        {
                                          staticClass: "accent--text",
                                          attrs: { sm1: "" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                small: "",
                                                color: "accent"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.removeLocation(
                                                    index,
                                                    _vm._.get(location, "label")
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                Remove\n              "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", {
                                key: "divider_" + index,
                                staticClass: "my-1"
                              })
                            ]
                          })
                        ],
                        2
                      )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d573e50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d573e50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/LoadingChutesSection.vue
// module id = null
// module chunks = 